<template>
  <div class="collapsible-card" :class="classObj" @click="() => bodyCollapsed = !bodyCollapsed">
    <div class="collapsible-card-body">
      <div class="collapsible-card-header" :class="!bodyCollapsed ? 'collapsible-card-header-accent' : ''">
        <slot name="header">HEADER</slot>
      </div>
      <div class="collapsible-card-spacer"></div>

      <div class="collapsible-card-icon-container" :class="!bodyCollapsed ? 'collapsible-card-icon-container-accent' : ''">
        <i class="fas fa-angle-down" :class="iconTransisition" v-if="!isVM"></i>
        <img v-if="isVM" :src="require('../assets/theme/' + resellerId + '/images/cross_themeAccent.svg')" alt="Toggle" title="Toggle" class="icon" :class="iconTransisition" />
      </div>

      <transition name="collapsible-card-fade" mode="in-out">
        <div v-show="!bodyCollapsed" class="collapsible-card-body-text">
          <slot name="body">BODY</slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "CollapsibleCard",
  props: {
    isTabbed: {
      type: Boolean,
      default: false,
      notes:
        "a bool to determine if the guide is within a tabbed document or freestanding, adds a class that overides standard media queries"
    }
  },
  data: () => {
    return {
      bodyCollapsed: true
    };
  },
  computed: {
    iconTransisition() {
      if (!this.bodyCollapsed) {
        return "icon-rotate icon-rotate-down";
      } else if (this.bodyCollapsed) {
        return "icon-rotate";
      }
    },
    classObj() {
      let klass = {};
      this.isTabbed
        ? (klass["collapsible-card-tabbed"] = true)
        : (klass["collapsible-card-untabbed"] = true);

      return klass;
    },
    resellerId() {
      return process.env.VUE_APP_RESELLER_ID
    },
    isVM() {
      return process.env.VUE_APP_RESELLER_ID == 77
    }
  }
};
</script>

